<div (click)="onCardClick()" class="reputation-mini-card-wrap" [class.dark]="dark$ | async">
  <div *ngIf="!isSidebar" class="reputation-mini-card" [class.reputation-mini-card--clickable]="clickable" [class.dark]="dark$ | async"
    [ngStyle]="cardInfoStyle" [style.--zoom]="zoom" [style.--status-color]="statusAccentColor"
    [attr.role]="clickable ? 'button' : null" [attr.tabindex]="clickable ? 0 : null" (click)="onCardClick()"
    (keydown)="onCardKeydown($event)">
    <div class="reputation-mini-card__badge" aria-hidden="true">
      <div class="reputation-mini-card__badge-inner">
        @if (currentStatusIconUrl) {
        <img [src]="currentStatusIconUrl" [alt]="currentStatusTitle" />
        } @else {
        <span class="reputation-mini-card__badge-fallback">{{ currentStatusTitle | slice: 0:1 }}</span>
        }
      </div>
    </div>

    <div [ngStyle]="darkTheme" class="reputation-mini-card__panel">
      <div class="reputation-mini-card__points" dir="ltr">
        <span class="reputation-mini-card__points-current">{{ currentPointsLabel }}</span>
        <span class="reputation-mini-card__points-divider">/</span>
        <span class="reputation-mini-card__points-target">{{ targetPointsLabel }}</span>
        <img class="reputation-mini-card__points-icon" [src]="loyaltyIconSrc" alt="" aria-hidden="true" />
      </div>

      <div class="reputation-mini-card__progress-row" dir="ltr">
        <div class="reputation-mini-card__progress" aria-hidden="true">
          <div class="reputation-mini-card__progress-fill" [style.width.%]="progressValue"></div>
        </div>
        <span class="reputation-mini-card__progress-value">{{ progressValue | number: '1.0-0' }}%</span>
      </div>

      @if (!isFinalLevel) {
      <p class="reputation-mini-card__next">
        <strong class="fs-17">{{ remainingPointsLabel }}</strong>
        <img class="reputation-mini-card__points-icon" [src]="loyaltyIconSrc" alt="" aria-hidden="true" />
      </p>
      <div class="fs-13">{{ 'REPUTATION_UNLOCK_LEVEL' | translate: { level: nextStatusTitle } }}</div>
      } @else {
      <p class="reputation-mini-card__next reputation-mini-card__next--final">
        {{ 'REPUTATION_STATUS_FINAL' | translate }}
      </p>
      }
    </div>
  </div>

  @if (countdownVisible && countdownBlocks && activeLevelInactivityWarning) {
  <div class="reputation-mini-card__countdown">
    <p class="reputation-mini-card__countdown-text">
      {{'RISK_LOSING' | translate}}
      <strong>{{ formatPoints(activeLevelInactivityWarning.lossAmount) }}</strong>
      <img class="reputation-mini-card__points-icon" [src]="loyaltyIconSrc" alt="" aria-hidden="true" />
      {{'IN' | translate}}
    </p>
    <div class="reputation-mini-card__countdown-timer">
      <span class="reputation-mini-card__countdown-unit">
        <strong>{{ countdownBlocks.days | number: '2.0-0' }}</strong>
        <small>{{ 'DAYS' | translate }}</small>
      </span>
      <span class="reputation-mini-card__countdown-unit">
        <strong>{{ countdownBlocks.hours | number: '2.0-0' }}</strong>
        <small>{{ 'HOURS' | translate }}</small>
      </span>
      <span class="reputation-mini-card__countdown-unit">
        <strong>{{ countdownBlocks.minutes | number: '2.0-0' }}</strong>
        <small>{{ 'MINUTES' | translate }}</small>
      </span>
      <span class="reputation-mini-card__countdown-unit">
        <strong>{{ countdownBlocks.seconds | number: '2.0-0' }}</strong>
        <small>{{ 'SECONDS' | translate }}</small>
      </span>
    </div>
  </div>
  }
</div>